import {useState} from "react";
import DatePickerComponent from "../../components/DatePickerComponent";
import {useSelector} from "react-redux";
import {selectAllCities} from "../common-states/commonStatesSlice";

const ReportingMenu = ({date, period, handlePeriodChange, handleEndDateChange, handleStartDateChange, handleSearch, handleGetExcel}) => {
    const allCities = useSelector(selectAllCities)
    const [selected, setSelected] = useState({waterType: 'شرب و دام', filter: 'همه', city: ''})

    const handleSelectChange = (e) => {
        let name = e.target.name;
        setSelected({...selected, [name]: e.target.value})
    }

    return(
        <div className='report-menu'>
            <div className='excel-box'>
                <button onClick={() => handleGetExcel(selected.waterType, selected.city)}>اکسل</button>
                <select name='waterType' value={selected.waterType} onChange={handleSelectChange}>
                    <option value='شرب و دام'>شرب و دام</option>
                    <option value='شرب انسان'>شرب انسان</option>
                    <option value='شرب دام'>شرب دام</option>
                </select>
            </div>
            <div className='report-search-box'>
                <div className='box-hint'>جستجو</div>
                <div className='filter-and-show-box'>
                    <button onClick={() => handleSearch(selected.city ? `city_id=${selected.city}` : '', selected.filter)}>نمایش</button>
                    <select name='filter' value={selected.filter} onChange={handleSelectChange}>
                        <option value='همه'>همه</option>
                        <option value='تحویل شده'>تحویل شده</option>
                    </select>
                    <select name='city' value={selected.city} onChange={handleSelectChange}>
                        <option value=''>همه شهرها</option>
                        {allCities.map((item, index) => {
                            return <option key={index} value={item.city_id}>{item.name}</option>
                        })}
                    </select>
                </div>
                <div className='two-datepicker'>
                    <DatePickerComponent preSelected={date.endDate.toString()} handleChange={handleEndDateChange} label=':تا' />
                    <DatePickerComponent preSelected={date.startDate.toString()} handleChange={handleStartDateChange} label=':از' />
                </div>
                <div className='radio-button-box'>
                    <div>
                        <label htmlFor='month'>ماه اخیر</label>
                        <input type='radio' name='date' id='month' value='month' checked={period === 'month'} onChange={handlePeriodChange} />
                    </div>
                    <div>
                        <label htmlFor='week'>هفته اخیر</label>
                        <input type='radio' name='date' id='week' value='week' checked={period === 'week'} onChange={handlePeriodChange} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportingMenu